import React from "react";
import DistributionStaff from "components/Tvendo/Distribution/DataMaster/DistributionStaff/List";

export default function () {
  return <DistributionStaff />;
}
